const LocatedIcon = ({ width = 20, height = 20, color = '#444446' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M9.98698 17.9443C9.98698 17.9443 16.6536 13.5874 16.6536 8.55036C16.6536 4.95859 13.6689 2.04688 9.98698 2.04688C6.30508 2.04688 3.32031 4.95859 3.32031 8.55036C3.32031 13.5874 9.98698 17.9443 9.98698 17.9443Z"
        stroke={color}
        strokeWidth="1.66667"
      />
      <path
        d="M10.0026 11.0208C11.2682 11.0208 12.2943 9.99481 12.2943 8.72917C12.2943 7.46352 11.2682 6.4375 10.0026 6.4375C8.73696 6.4375 7.71094 7.46352 7.71094 8.72917C7.71094 9.99481 8.73696 11.0208 10.0026 11.0208Z"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LocatedIcon
